import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-case-studies',
  imports: [RouterLink],
  templateUrl: './case-studies.html',
  styleUrl: './case-studies.scss'
})
export class CaseStudies {

}
